import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import i18n from './language'; // global language
import '@/icons'; // icon

/* 组件 */
import ElementUI from 'element-ui';
import './assets/css/element-variables.scss';
Vue.use(ElementUI);

import './components/index'; // 全局组件注册

/* 插件、配置 */
import '@/assets/css/index.scss'; //global css
import '@/assets/iconfont/iconfont.css'
import '@/permission'; // permission control
import './directive/index'; // global directive
import './filter/index'; // global filter
import baseUrl from './config'; // global baseUrl
import UIConfig from './UIconfig'; // global UIConfig
import server from './services/server'; //global api
import { api } from '@/services/server.js'; // api src
import globalMixin from '@/mixins/index.js'; // 全局mixin
import commonData from '@/mixins/common-data.js';
import storeage from '@/util/storeage';
import htmlToPdf from '@/util/pdf.js'; // 下载为pdf
import utils from './util/index'; // global utils
import VueCropper from 'vue-cropper'; // 头像裁剪
//引入video.js文件
import Videojs from 'video.js';
import 'videojs-flash';
import 'video.js/dist/video-js.css';

//echarts5.0的引入方式
import * as echarts from 'echarts';
// 时间格式化
import moment from 'moment';

Vue.use(VueCropper);
Vue.prototype.$echarts = echarts;
Vue.prototype.$video = Videojs;
Vue.mixin(globalMixin);
Vue.mixin(commonData);
Vue.use(htmlToPdf);
Vue.prototype.$server = server; // 请求方法
Vue.prototype.$api = api; // 下载api路径
Vue.prototype.$utils = utils; // 全局方法、功能函数
Vue.prototype.$baseUrl = baseUrl; // 全局基础路由
Vue.prototype.$UIConfig = UIConfig; // 全局页面img
Vue.prototype.$sg = storeage; // 本地存储
Vue.prototype.$moment = moment; // 时间格式化
Vue.prototype.$bus = new Vue(); // 组件通讯

// 根据端引入字体包css
if(utils.winOrMac() == 'win'){
    require('@/assets/css/fonts-win.css'); //global css
}else{
    require('@/assets/css/fonts-mac.css'); //global css
}

new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
}).$mount('#app');
